/**
 * Navigation Items Configuration for AZ Translate - Quote Management Portal
 *
 * Defines the main navigation structure for the sidebar component.
 */

import config from '../../config';

export interface NavItem {
  /** Display label for the navigation item */
  label: string;
  /** Material Symbols icon name */
  icon: string;
  /** Icon set (defaults to 'material-symbols-outlined') */
  iconSet?: string;
  /** Router path */
  route: string;
  /** Whether to hide this item from navigation */
  hide?: boolean;
  /** Whether this link opens in a new tab/window */
  external?: boolean;
  /** Tooltip or aria-label text (optional) */
  title?: string;
}

/**
 * Main navigation items for AZ Translate application
 * Order matches the design mockup from top to bottom
 */

const isProd = config.environment_name === 'prod';

const DEEPL_FREE_TEXT_URL = isProd
  ? 'https://www.astrazeneca.app.deepl.com/translator'
  : 'https://uat-astrazeneca.app.deepl.com/translator';

const DEEPL_FILES_URL = isProd
  ? 'https://www.astrazeneca.app.deepl.com/translator/files'
  : 'https://uat-astrazeneca.app.deepl.com/translator/files';

export const NAV_ITEMS: NavItem[] = [
  {
    label: 'DeepL Translator',
    icon: 'translate',
    route: DEEPL_FREE_TEXT_URL,
    external: true,
    title: 'Use our AI powered translation tool for plain text.',
  },
  {
    label: 'Translate Files',
    icon: 'description',
    route: DEEPL_FILES_URL,
    external: true,
    title:
      'Upload your documents and have them immediately translated with our AI Translation tool.',
  },
  {
    label: 'New Request',
    icon: 'article_person',
    route: '/vendor-translation',
    title: 'Vendor translation process for regulatory documentation',
  },
  {
    label: 'Translation Manager',
    icon: 'library_books',
    route: '/translation-manager',
    title: 'Manage translation projects and workflows',
  },
  {
    label: 'NGS',
    icon: 'genetics',
    route: '/ngs',
    title: 'NGS translation process for regulatory documentation',
  },
];
